<template>
    <div class="mb-2 pa-2">
      <p>
        <b v-html="this.textos.descripcion"></b>
      </p>
      <div class="mt-0">              
        <v-card flat tile  class="pa-3">
          <v-window v-model="onboardingA" :touchless="true" :class="retroaliment">
            <v-window-item v-for="(dropItem, index) in dropList" :key="'item'+index">
              <div class="info-drop">
                {{dropItems[index]}}
              </div>
              <div class="mt-2 cont-drop-e">
                <draggable v-model="dropList[index]" @change="change($event, index)" :options="{group:'items'}" class="item-drop">
                  <div v-for="element in dropList[index]" :key="element" class="area-drop">
                    <span v-html="element"></span>
                  </div> 
                </draggable>
              </div>
            </v-window-item>
          </v-window>
        </v-card>
      </div>
      <div xs12>
        <div class="d-flex justify-center my-2 ">
          <div class="circle-btn hvr-scale" v-for="(item, index) in activateBtn" :key="index" 
          :class="{'inactivo': !activateBtn[activateBtn.length - 1]} "
          @click="onboardingA = index">
            <div class="circle" :class="{'active':activateBtn[index]}"></div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <p v-if="dragItems.length > 0" class="mb-2" ><b>Respuestas:</b></p>
        <div class="cont-drag"  v-if="dragItems.length > 0">
          <v-window v-model="onboarding">
            <draggable v-model="dragItems" @start="saveEl" :options="{group:'items'}" class="item-drag">
              <v-window-item v-for="(element , n) in dragItems" :key="'element-'+n" class="pa-2 ">
                <div class="btn-drag hvr">
                  <span v-html="element"></span>
                </div>
              </v-window-item>
            </draggable>
          </v-window>
        </div>
        <div class="d-flex align-center my-3" :class="$vuetify.breakpoint.xs ? 'justify-space-between' : 'justify-center'" 
        v-if="dragItems.length>0">
          <v-btn  fab small @click="prev" class="mr-3">
            <v-icon size="40">navigate_before</v-icon>
          </v-btn>
          <v-btn fab small @click="next" class="ml-3">
            <v-icon size="40">navigate_next</v-icon>
          </v-btn>
        </div>
      </div>
      <!-- Modal de respuestas  -->
      <respuesta-app  v-model="modalRetro" :fullscreen="false" :width="'500px'" :colorSuperior="bcorrecta ?'success' : 'error'">
          <template slot="modaltittle"></template>
          <template slot="modalcontent">
            <div class="text-center pa-2 animated flipInY dura-1">
              <v-icon size="70" class="mx-auto" :color="bcorrecta ?'success' : 'error'">
                {{bcorrecta ?'mdi-check-circle-outline' : 'mdi-close-circle-outline'}} </v-icon>
            </div>
            <div class="pa-4 cont-texto-retro">
              <p class="text-center mb-0" v-html="retroTexto"> </p>
            </div>
          </template>
      </respuesta-app>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
  components:{
    draggable,
  },
  props:{
    dataTrivia:{},

  },
  data() {
    return {
      length: null,
      lengthA: null,
      onboarding: 0,
      onboardingA: 0,
      verTrivia: false,
      dragItems:[],
      dropItems:[],
      correctas:[],
      dropList:null,
      activateBtn: null,
      retroaliment: '',
      actualSlot: null,
      retroTexto:'',
      modalRetro:false,
      textos:null,
      bcorrecta:true,
      contador:0,
    }
  },
 async mounted() {
  this.textos = {
    titulo: this.dataTrivia[0].titulo,
    descripcion:this.dataTrivia[0].texto,
    msgIncorrecto:this.dataTrivia[0].retro_incorrecto,
    msgCorrectoFinal:this.dataTrivia[0].retro_correcto,
    msgCorrecto:'¡Felicidades! Ha respondido correctamente la pregunta.',

  }
  let temporaAlrray = []
   await this.dataTrivia.forEach(element => {
      this.dropItems.push(element.pregunta)
      temporaAlrray.push(element.respuesta)
      this.correctas.push(element.respuesta)
      this.dropList = Array(temporaAlrray.length).fill([])
      this.activateBtn = Array(temporaAlrray.length).fill(false)
      this.length = temporaAlrray.length
      this.lengthA = temporaAlrray.length
    });
    this.dragItems = temporaAlrray
    this.dragItems.reverse()
    this.verTrivia = true
  },
  methods: {
    saveEl(ev) {},
    change(ev, slotNum) {
      this.actualSlot = slotNum;
      if (this.dropList[slotNum] == this.correctas[slotNum]) {
        this.contador++
        // console.log(this.contador)
        this.retroaliment = "animated pulse";
        this.$set(this.activateBtn, slotNum, true)
        if (this.contador === 3 ){
          this.retroTexto = this.textos.msgCorrectoFinal
        }else{
          this.retroTexto = this.textos.msgCorrecto
        }
        this.modalRetro = true
        this.bcorrecta = true
        setTimeout(() => {
            this.onboarding++;
            this.nextA();
            this.next();
            this.retroaliment = "";

        }, 1000);
      }else{
        this.retroaliment = "mal animated shake";
        // console.log('incorrecta')
        this.retroTexto = this.textos.msgIncorrecto
        this.modalRetro = true
        this.bcorrecta = false
        setTimeout(() => {
          this.onboarding++;
          var ubicacion = this.dragItems.indexOf(this.dropList[slotNum]);
          this.dragItems.splice(ubicacion, 0, this.dropList[slotNum].join(""));
          this.$set(this.dropList, this.actualSlot, []);
          this.retroaliment = "";
        }, 1000);
      }
    },
    aleatorio(arr){
      arr.sort(() => { return Math.random() - 1.5 })
      // console.log(arr)
    },
    nextA() {
        this.onboardingA =
          this.onboardingA + 1 === this.lengthA ? 0 : this.onboardingA + 1;
      },
      prevA() {
        this.onboardingA =
          this.onboardingA - 1 < 0 ? this.lengthA - 1 : this.onboardingA - 1;
      },
      next() {
        this.onboarding =
          this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
      },
      prev() {
        this.onboarding =
          this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
      },
  },
}
</script>
<style lang="scss" scoped>
.cont-texto-retro{
  font-weight: 600;
  font-size: 1.2em;
}
.cont-trivia{
  display: flex;
  flex-wrap:wrap;
  align-content: stretch;
}
.cont-col-trivia{
  display: flex;
  flex-wrap:wrap;
  justify-content: center;
  align-content: stretch;
}
.info-drop{
  background: #C5E2BB;
  width: 100%;
  padding: 10px;
  text-align: center;
}
.cont-drop-e{
  width: 100%;
  min-height: 120px;
  .item-drop{
    width: 100%;
    min-height: 120px;
    border: solid 1px #0B542D;
    padding: 10px;
    .area-drop{
      min-height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.cont-drag{
  width: 100%;
  .item-drag{
    background: #C5E2BB;
    width: 100%;
    min-height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}
.btn-drag{
  cursor: pointer;
   min-height: 100px;
   display: flex;
   justify-content: center;
   align-items: center;
}
.inactivo{
  pointer-events: none!important;
}
.circle-btn{
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  margin-right: 10px;
  .circle{
    width: 1.25rem;
    height: 1.25rem;
    background: #FFF;
    border-radius: 50%;
    text-align: center;
    font-size: 10px;
    color:#FFF;
    font-weight: 700;
    cursor: pointer;
    border: 3px solid #acadac;
    &:hover, &.active{
      background: #E7C435;
    }
  }
}
</style>